import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("ErrorBoundary caught:", error, info);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div data-testid="app-error" style={{ padding: 20, fontFamily: "monospace", color: "#b91c1c" }}>
          <h2 style={{ fontWeight: 700, fontSize: 18 }}>Something went wrong</h2>
          <pre data-testid="app-error-msg" style={{ whiteSpace: "pre-wrap", fontSize: 13 }}>
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: 11, color: "#6b7280" }}>
            {this.state.info?.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
